import React from 'react'
import { Navigation } from '../components/Navbar'
import { HeroSection } from '../components/HeroSection'
import { AboutSection } from '../components/AboutSection'
import { TechnologySection } from '../components/TechnologySection'
import { ImpactSection } from '../components/ImpactSection'
import { ProjectsSection } from '../components/ProjectsSection'
import { ContactSection } from '../components/ContactSection'
import { Footer } from '../components/Footer'

const Home = () => {
  return (
    <main className="w-full min-h-screen bg-white selection:bg-ocean-medium/30 selection:text-ocean-dark">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <TechnologySection />
      <ImpactSection />
      <ProjectsSection />
      <ContactSection />

<Footer />

      {/* Footer */}
      <footer className="py-12 bg-white border-t border-ocean-light text-center">
        <p className="text-ocean-dark/40 text-sm font-light tracking-widest uppercase">
          © {new Date().getFullYear()} Enersic. All rights reserved.
        </p>
      </footer>
    </main>
  )
}

export default Home;